import React, { createContext, useState, useContext } from "react";

// Create the context
const ToastContext = createContext();

// Create a provider component
export const ToastProvider = ({ children }) => {
  // Toast state
  const [toast, setToast] = useState({
    show: false,
    header: "",
    message: "",
    type: "info", // success, danger, warning, info
  });

  // Function to show toast
  const showToast = (header, message, type = "info") => {
    setToast({
      show: true,
      header,
      message,
      type,
    });

    // Auto hide after 3 seconds
    setTimeout(() => {
      setToast((prev) => ({ ...prev, show: false }));
    }, 3000);
  };

  // Function to hide toast
  const hideToast = () => {
    setToast((prev) => ({ ...prev, show: false }));
  };

  return (
    <ToastContext.Provider
      value={{
        toast,
        showToast,
        hideToast,
      }}
    >
      {children}
    </ToastContext.Provider>
  );
};

// Custom hook to use the toast context
export const useToast = () => {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};
